import { Dispatch, GetStore, Store } from '../';
import { SET_EDIT_MODE, SET_MOBILE_MODE } from './layout.actions';

export interface ILayoutActionCreatorService {
    setMobileMode(isMobileMode: boolean): (dispatch: Dispatch<any>, getStore: GetStore) => void;
    setEditMode(isEditMode: boolean): (dispatch: Dispatch<any>, getStore: GetStore) => void;
}

export class LayoutActionCreatorService implements ILayoutActionCreatorService {
    static serviceId = 'layoutActionCreatorService';
    static $inject = [];

    setMobileMode(isMobileMode: boolean): (dispatch: Dispatch<any>, getStore: GetStore) => void {
        return (dispatch: any, getState: () => Store) => {
            dispatch({ type: SET_MOBILE_MODE, payload: { isMobileMode } });
        };
    }

    setEditMode(isEditMode: boolean): (dispatch: Dispatch<any>, getStore: GetStore) => void {
        return (dispatch: any, getState: () => Store) => {
            dispatch({ type: SET_EDIT_MODE, payload: { isEditMode } });
        };
    }
}